import { Button } from '@/components/ui/button';
import { LogOut } from 'lucide-react';
import ThemeToggle from '@/components/ThemeToggle';

export function SidebarFooter({ user, onLogout }) {
  return (
    <div className="p-4 border-t border-white/10">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center">
          {user?.picture ? (
            <img src={user.picture} alt={user.name} className="w-9 h-9 rounded-full mr-2.5 border-2 border-white/20" />
          ) : (
            <div className="w-9 h-9 rounded-full bg-white/15 flex items-center justify-center mr-2.5">
              <span className="text-white font-medium text-sm">
                {user?.name?.charAt(0) || 'U'}
              </span>
            </div>
          )}
          <div className="min-w-0">
            <p className="text-sm font-medium text-white truncate">{user?.name}</p>
            <p className="text-xs text-white/50 capitalize">{user?.role?.replace('_', ' ')}</p>
          </div>
        </div>
        <ThemeToggle />
      </div>
      <Button
        variant="outline"
        className="w-full border-white/15 text-white/70 hover:bg-white/10 hover:text-white bg-transparent"
        onClick={onLogout}
        data-testid="logout-btn"
      >
        <LogOut className="w-4 h-4 mr-2" /> Cerrar sesion
      </Button>
    </div>
  );
}
